// Header.js
import React from 'react';
import './Header.css'; // File CSS per lo stile dell'header
import Navigation from './Navigation';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header className="main-header">
            <div className="logo">
                <Link to="/">
                    <img src="logo_site_icon_white.jpg" alt="Logo" />
                </Link>
            </div>
            <Navigation />
        </header>
    );
};

export default Header;